var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Icon from '../../../Icon';
const IconOvernight = (_a) => {
    var { size, fill } = _a, commonProps = __rest(_a, ["size", "fill"]);
    const iconContent = {
        content: (React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { d: "M19.191 14.217C18.309 14.6153 17.4592 14.7878 16.386 14.7878C12.4237 14.7878 9.21225 11.5763 9.21225 7.61402C9.21225 6.54152 9.38475 5.69177 9.783 4.80827C10.0672 4.17827 9.42075 3.53177 8.79075 3.81602C5.69925 5.21327 3.75 8.14277 3.75 11.5748C3.75 16.365 7.63425 20.2493 12.4245 20.2493C15.8572 20.2493 18.786 18.3008 20.1832 15.2085C20.4682 14.5785 19.821 13.9313 19.191 14.2163V14.217ZM7.71225 7.61402C7.71225 12.4043 11.5957 16.2878 16.386 16.2878C16.9035 16.2878 17.385 16.2525 17.8462 16.1783C16.5472 17.7953 14.616 18.75 12.4245 18.75C8.46225 18.75 5.25 15.5378 5.25 11.5755C5.25 9.38402 6.20475 7.45202 7.82175 6.15377C7.7475 6.61577 7.71225 7.09727 7.71225 7.61402Z", fill: "black" }))),
        alt: 'Overnight',
    };
    return React.createElement(Icon, Object.assign({}, commonProps, { source: iconContent, size: size, fill: fill }));
};
export default IconOvernight;
//# sourceMappingURL=index.js.map